import React, { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { ReceiptTodoSelectionFormContainerProps } from "models/propTypes/receiptPropTypes";
import { FormHandles } from "models/propTypes/genericFormProps";
import { ReceiptFormTypes } from "models/formTypes";
//#endregion
//#region components
import ReceiptTodoSelectionForm from "./todoSelectionForm";
import useReceiptTodoFormHelpers from "./helpers/useTodoFormHelpers";
import { CostForwardingMarkingProvider, useReceiptTodoCostForwarding } from "components/costForwardingMarking";
//#endregion

const ReceiptTodoSelectionFormContainer: ForwardRefRenderFunction<
  FormHandles,
  ReceiptTodoSelectionFormContainerProps
> = (props, ref) => {
  const {
    receipt,
    fileViewer,
    showFullForm,
    onUploadedFilesChangeHandler,
    receiptManualPaymentChangeHandler,
    ...formProps
  } = props;

  const { validationSchema, initialValues } = useReceiptTodoFormHelpers(receipt, showFullForm);
  const { costForwardingContext, latestCostForwardingValues } = useReceiptTodoCostForwarding(receipt);

  const defaultValues = React.useMemo(
    (): ReceiptFormTypes.Todo => ({ ...initialValues, ...latestCostForwardingValues.current }),
    [initialValues]
  );

  const handleSubmit = async (values: ReceiptFormTypes.Todo) => values;

  return (
    <CostForwardingMarkingProvider value={costForwardingContext}>
      <ReceiptTodoSelectionForm
        ref={ref}
        {...formProps}
        receipt={receipt}
        defaultValues={defaultValues}
        handleSubmit={handleSubmit}
        validationSchema={validationSchema}
        fileViewer={fileViewer}
        showFullForm={showFullForm}
        receiptManualPaymentChangeHandler={receiptManualPaymentChangeHandler}
        onUploadedFilesChangeHandler={onUploadedFilesChangeHandler}
      />
    </CostForwardingMarkingProvider>
  );
};

export default forwardRef(ReceiptTodoSelectionFormContainer);
